/** Internal helper imports here ... */

/**
 * Module description...
 *
 * @returns {{init: init}}
 */
const scrollNav = (() => {

  const DOM = {};

  const cacheDOM = () => {
    DOM.sections = document.getElementsByTagName('section');
    DOM.navLI = document.querySelectorAll('.menu-item');
    DOM.windowHeight = window.innerHeight;
    DOM.header = document.getElementById('header');
  };

  const scroll = () => {
    let fromTop = window.pageYOffset;
    let curSection;
    let nextSection;

    for (let i = 0; i < DOM.sections.length; i++) {
      let divPos = DOM.sections[i].offsetTop;
      let id;

      if (divPos - 1 < fromTop) {
        curSection = DOM.sections[i];
        nextSection = DOM.sections[i + 1];
      }

      id = curSection.getAttribute('id');

      if (id === '') {
        curSection = DOM.sections[i - 1];
        id = curSection.getAttribute('id');
      }

      for (let i = 0; i < DOM.navLI.length; i++) {
        let a = DOM.navLI[i].getElementsByTagName('a');
        let ahref = a[0].getAttribute('href');

        if (ahref === '#' + id) {
          a[0].classList.add('active');
        } else {
          a[0].classList.remove('active');
        }
      }
    }
  };

  const windowLoadScroll = () => {

    let windowTop = window.pageYOffset;
    let windowBottom = windowTop + window.innerHeight;

    let group = document.getElementsByTagName('section');

    for (let i = 0; i < group.length; i++) {
      let elementTop = group[i].offsetTop;

      if (windowBottom > (elementTop + group[i].offsetHeight * .5)) {
        group[i].classList.add('fixed-place');
      }
    }

    if (windowBottom === DOM.docHeight) {
      console.log('bottom');
    }
  };

  const eventListeners = () => {
    window.addEventListener('scroll', () => {
      scroll();
      windowLoadScroll();
    });
    window.addEventListener('load', () => {
      DOM.sections[0].classList.add('fixed-place');
    });
  };

  function init() {
    cacheDOM();
    eventListeners();
  }

  return {
    init
  };
})();

export default scrollNav;
